import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Container,
} from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const MaterialRequest = () => {
const [selectedItems, setSelectedItems] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [materialData, setMaterialData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(""); // format: YYYY-MM

const handleCheckboxChange = (childId) => {
  setSelectedItems((prevSelected) =>
    prevSelected.includes(childId)
      ? prevSelected.filter((id) => id !== childId)
      : [...prevSelected, childId]
  );
};
  useEffect(() => {
    if (selectedMonth) {
      fetchMaterialRequest();
    }
  }, [selectedMonth]);

  const fetchMaterialRequest = async () => {
    if (!selectedMonth) {
      toast.error("Please select a month.");
      return;
    }

    const [year, month] = selectedMonth.split("-");
    try {
      setIsLoading(true);

      const response = await fetch(
        `https://api.hanoch.in/production_planning/material-plan/?month=${parseInt(
          month
        )}&year=${year}`
      );

      if (response.ok) {
        const data = await response.json();
        console.log("this is material request", data);
        setMaterialData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
      setIsLoading(false);
    }
  };
const handlePrint = () => {
  const selectedGroupedData = materialData
    .map((item) => {
      const selectedChildren = item.child_parts?.filter((child) =>
        selectedItems.includes(child.id)
      );
      if (selectedChildren.length === 0) return null;

      return {
        part_name: item.part_name,
        children: selectedChildren.map((child) => ({
          part_number: child.part_number,
          quantity_required: child.quantity_required_for_this_month,
          current_stock: child.current_stock,
          stock_to_request: child.stock_to_be_requesting,
        })),
      };
    })
    .filter(Boolean); // remove nulls

  const tableHTML = `
    <html>
      <head>
        <title>Print Material Request</title>
        <style>
          body { font-family: Arial, sans-serif; }
          table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f2f2f2;
          }
          .section-header {
            background-color: #d3d3d3;
            font-weight: bold;
            text-align: center;
          }
        </style>
      </head>
      <body>
        <h2 style="text-align:center;">Material Request</h2>

        ${selectedGroupedData
          .map(
            (group) => `
            <table style="width:100%; margin-bottom: 30px;">
              <tr class="section-header">
                <td colspan="5">${group.part_name}</td>
              </tr>
              <tr>
                <th>Material Number</th>
                <th>Quantity Required</th>
                <th>Current Stock</th>
                <th>Stock to Request</th>
              </tr>
              ${group.children
                .map(
                  (child) => `
                <tr>
                  <td>${child.part_number}</td>
                  <td>${child.quantity_required}</td>
                  <td>${child.current_stock}</td>
                  <td>${child.stock_to_request}</td>
                </tr>
              `
                )
                .join('')}
            </table>
          `
          )
          .join('')}
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  printWindow.document.write(tableHTML);
  printWindow.document.close();
  printWindow.print();
};


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Material Request" />
          <Row>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col md={3}>
                        <label>Select Month</label>
                        <input
                          type="month"
                          className="form-control"
                          value={selectedMonth}
                          onChange={(e) => setSelectedMonth(e.target.value)}
                        />
                      </Col>
                      <Col md="auto" className="align-self-end justify-contend-end">
                        {/* <Button color="primary" onClick={fetchMaterialRequest}>
                          Fetch Plan
                        </Button> */}
                        <Button
  color="success"
  onClick={() => handlePrint()}
  disabled={selectedItems.length === 0}
>
  Print Selected
</Button>
                      </Col>

                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            // value={searchTerm}
                            //onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table table-bordered">
                       
                       {isLoading ? (
  <div className="text-center my-4">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
                        ) : (
                         <tbody>
  {materialData.map((item, index) =>
   <React.Fragment key={index}>
      {/* Section Header */}
    <tr style={{ backgroundColor: "#fff", color: "#fff", fontWeight: "bold", textAlign: "center" }}>
  <td colSpan="6">{item.part_name}</td>
</tr>
 
                          <tr>
                             <th>Select</th>
                            {/* <th>Program</th> */}
                            <th>Material Number</th>
                            
                            <th>Quantity required for this month</th>
                            <th>Current Stock</th>
                            <th>Stock to Request</th>
                          </tr>
                        
    {item.child_parts?.map((child, idx) => (
      <tr key={`${item.part_name}-${child.id}`}>
        <td>
          <input
            type="checkbox"
            checked={selectedItems.includes(child.id)}
            onChange={() => handleCheckboxChange(child.id)}
          />
        </td>
        {/* <td>{item.part_name}</td> */}
        <td>{child.part_number}</td>
       
        <td>{child.quantity_required_for_this_month}</td>
        <td>{child.current_stock}</td>
        <td>{child.stock_to_be_requesting}</td>
      </tr>
    ))}
    </React.Fragment>
  )}
</tbody>
                        )}
                      </table>

                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default MaterialRequest;
